import {Model} from '@vuex-orm/core';
import User from "./userModel";
import ContactPoint from "./contactPointModel";
import Partner from "./partnerModel";

export default class Task extends Model {

    static entity = 'task';
    static primaryKey = 'id_task';

    static fields() {
        return {
            id_task: this.number(null),
            title: this.string(null),
            description: this.string(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            status: this.number(null),
            recurring_type: this.number(null),
            id_assignee: this.attr(null),
            id_partner: this.attr(null),
            done_at: this.attr(null),
            assignee: this.hasOne(User, 'id_user', 'id_assignee'),
            partner: this.hasOne(Partner, 'id_partner', 'id_partner'),
            contact_points: this.hasMany(ContactPoint, 'id_task'),
            users: this.attr(null),
        };
    }

    static status = {
        workReady: 0,
        inProgress: 1,
        done: 2,
    };

    static dueThreshold = 28;
}